export default "__VITE_ASSET__CEJV2R3u__"